import {useEffect, useState} from "react";
import {text} from "../util/constants";
import * as XLSX from 'xlsx'

export default function QuotationsViewBySites({state}) {


    const [selectedRow, setSelectedRow] = useState(null)
    const getBeautifulAmount = (value) => {
        let val = value
        val =  new Intl.NumberFormat('fr-FR')?.format(val)
        return val
    }

    useEffect(() => {}, [state]);

    const exportToExcel = () => {
        // Créer un nouveau classeur
        const wb = XLSX.utils.book_new();

        // Traiter chaque site
        state?.quotationList?.forEach(site => {
            // Préparer les données pour ce site
            const sheetData = [];

            // Ajouter les en-têtes
            sheetData.push([
                "Commande Initiale",
                "Intervention",
                "N° Devis",
                "État",
                "Montant HT (€)"
            ]);

            // Traiter les devis pour ce site
            site.devis.forEach(devis => {
                // Garder trace des lignes pour la fusion des cellules
                const devisStartRow = sheetData.length;
                let devisHasRows = false;

                // Traiter les interventions pour ce devis
                devis.interventions.forEach(intervention => {
                    // Garder trace des lignes pour la fusion des cellules
                    const interventionStartRow = sheetData.length;
                    let interventionHasRows = false;

                    // Traiter les quotations pour cette intervention
                    intervention.quotations.forEach((quotation, index) => {
                        // Ajouter une ligne pour cette quotation
                        sheetData.push([
                            devis.clientIdBCommande,
                            `#${intervention.id}`,
                            quotation.odooRef,
                            text.STATUS_TRADUCTION[quotation.status],
                            quotation.amountUntaxed
                        ]);

                        devisHasRows = true;
                        interventionHasRows = true;
                    });

                    // Fusionner les cellules d'intervention si nécessaire
                    const interventionEndRow = sheetData.length - 1;
                    if (interventionHasRows && interventionEndRow > interventionStartRow) {
                        // Stocker la plage de fusion pour la colonne d'intervention (colonne B)
                        if (!wb.mergeCells) {
                            wb.mergeCells = [];
                        }
                        wb.mergeCells.push({
                            s: { r: interventionStartRow, c: 1 },
                            e: { r: interventionEndRow, c: 1 }
                        });
                    }
                });

                // Fusionner les cellules de devis si nécessaire
                const devisEndRow = sheetData.length - 1;
                if (devisHasRows && devisEndRow > devisStartRow) {
                    // Stocker la plage de fusion pour la colonne de devis (colonne A)
                    if (!wb.mergeCells) {
                        wb.mergeCells = [];
                    }
                    wb.mergeCells.push({
                        s: { r: devisStartRow, c: 0 },
                        e: { r: devisEndRow, c: 0 }
                    });
                }
            });

            const totalAmount = sheetData.slice(1).reduce((sum, row) => sum + (row[4] || 0), 0);

            sheetData.push([]);
            sheetData.push([]);

            sheetData.push([
                "TOTAL",
                "",
                "",
                "",
                totalAmount
            ]);

            // Créer la feuille de calcul pour ce site
            const ws = XLSX.utils.aoa_to_sheet(sheetData);

            // Appliquer les fusions de cellules si elles existent
            if (wb.mergeCells && wb.mergeCells.length > 0) {
                ws['!merges'] = wb.mergeCells;
                // Réinitialiser pour la prochaine feuille
                wb.mergeCells = [];
            }

            // Formater les cellules de montant
            const priceColumn = 4; // Colonne E (0-indexed)
            const range = XLSX.utils.decode_range(ws['!ref']);

            for (let row = 1; row <= range.e.r; row++) { // Commencer à 1 pour sauter l'en-tête
                const cellRef = XLSX.utils.encode_cell({r: row, c: priceColumn});
                if (ws[cellRef]) {
                    ws[cellRef].z = '#,##0.00 €';
                }
            }

            // Ajouter la feuille au classeur
            // Sanitiser le nom de la feuille pour éviter les caractères invalides
            const siteName = `${site.name}, ${site.cp} ${site.ville}`;
            const safeSheetName = siteName.replace(/[\[\]\*\/\\\?:]/g, '_').substring(0, 31);
            XLSX.utils.book_append_sheet(wb, ws, safeSheetName);
        });

        // Générer le fichier Excel et déclencher le téléchargement
        XLSX.writeFile(wb, "Vue_par_sites.xls", { bookType: 'xls' });
    };

    return (
        <div style={{display: "grid", width: "94vw", rowGap: ".5rem"}}>

            <button
                onClick={exportToExcel}
                style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer"
                }}
            >
                Exporter en Excel
            </button>

            <div style={{
                display: "inline-grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                width: "100%",
                justifyItems: "center",
                padding: ".5rem"
            }}>
                <div>
                    <b>Nom du site</b>
                </div>
            </div>
            {
                state?.quotationList?.map((quotation, index) =>
                    <div key={index} className={"site-quotation-row parent"}>
                        <div style={{
                            display: "inline-grid",
                            gridTemplateColumns: "repeat(4, 1fr)",
                            width: "100%",
                            justifyItems: "center"
                        }} onClick={() => setSelectedRow(selectedRow === quotation.id ? null : quotation.id)}>
                            <div>
                                <b>{quotation.name}</b>
                            </div>
                            <div>
                                {quotation.ville}
                            </div>
                            <div>
                                {quotation.cp}
                            </div>
                            <div>
                                {getBeautifulAmount(quotation.devis.flatMap(d => d.interventions).flatMap(i => i.quotations).reduce((acc, q) => acc+=q.amountUntaxed, 0))} €
                            </div>
                        </div>
                        <div style={{maxHeight: selectedRow === quotation.id ? "800px" : "0px"}} className={"panel"}>
                            {
                                quotation.devis.map((devis, index) =>
                                    <div key={index} className={"site-quotation-row"}>
                                        <div>
                                            <a target={"_blank"}
                                               href={`/devis/${devis.id}`}>{devis.clientIdBCommande}</a>
                                        </div>

                                        <div>
                                            {
                                                devis.interventions.map((intervention, index) =>
                                                    <div key={index}
                                                         className={"site-quotation-row"}>
                                                        <a target={"_blank"}
                                                           href={`/Intervention/${intervention.id}`}>Intervention
                                                            d'origine</a>


                                                        <div style={{
                                                            display: "inline-grid",
                                                            gridTemplateColumns: "repeat(3, 1fr)",
                                                            width: "100%",
                                                            justifyItems: "center"
                                                        }}>
                                                            <div>
                                                                N° devis
                                                            </div>
                                                            <div>
                                                                État du devis
                                                            </div>
                                                            <div>
                                                                Montant HT
                                                            </div>
                                                        </div>

                                                        {
                                                            intervention.quotations.map((quotation, index) =>
                                                                <div style={{
                                                                    display: "inline-grid",
                                                                    gridTemplateColumns: "repeat(3, 1fr)",
                                                                    width: "100%",
                                                                    justifyItems: "center"
                                                                }}>
                                                                    <div>
                                                                        <a target={"_blank"}
                                                                           href={`/quotation/${quotation.id}`}>{quotation.odooRef}</a>
                                                                    </div>
                                                                    <div>
                                                                        {text.STATUS_TRADUCTION[quotation.status]}
                                                                    </div>
                                                                    <div>
                                                                        {quotation.amountUntaxed} €
                                                                    </div>
                                                                </div>
                                                            )
                                                        }

                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}